.toast {
  border-radius: 2px;
  min-height: 50px;
  font-size: 1rem;
  z-index: 2000;
  background-color: var(--primary-30);
}

.success {
  color: var(--color-ffffff);
  background-color: var(--secondary-100);
}

.success .progress {
  background-color: var(--color-ffffff);
}

.error {
  color: var(--color-ffffff);
  background-color: var(--color-c2436f);
}
.error .progress {
  background-color: var(--color-ffffff);
}

.info {
  color: var(--primary-30);
  background-color: var(--primary-100);
}
.info .progress {
  background-color: var(--primary-30);
}
